import React from 'react';
import { Link } from 'react-router-dom';

import { Page, useAppLayoutContextConsumer } from '@occc-app/design-system';
import { Button, AddIcon } from '@occc/ui-design-system';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { ProductCategoriesTableContainer } from './ProductCategoriesTableContainer';
import { breadcrumbLinks } from './constants';

import { routeCreator } from '../utils';

const PAGE_TITLE = 'Product Preferences';

export const ProductCategoryListPage: React.FC = () => {
  useAppLayoutContextConsumer(breadcrumbLinks);
  const isUserPermittedToCreateCategory = useIsUserPermittedTo(Feature.PRODUCT_CATEGORY_CREATE);

  const actions = isUserPermittedToCreateCategory && (
    <Button
      color='secondary'
      variant='contained'
      component={Link}
      startIcon={<AddIcon />}
      to={routeCreator.create()}
      role='button'
    >
      create new product preference group
    </Button>
  );

  return (
    <Page browserTabTitle={PAGE_TITLE} actions={actions} pageHeaderProps={{ title: PAGE_TITLE }}>
      <ProductCategoriesTableContainer />
    </Page>
  );
};
